// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"57cb124d","264":"34b34525","480":"acae7a11","488":"8c7f3cc8"}[chunkId] + ".chunk.js";
};